import Grid from "@mui/material/Grid2";
import PublicTransportProvision from "../TripRate/Filters/PrimaryFiltering/PublicTransportProvision";
import { SecondaryFilterTickBox } from "../TripRate/Filters/SecondaryFiltering/SecondaryFilterTickbox";
import { SessionContext } from "../Contexts/SessionContext";
import React from "react";
import ResidentialUnitTypesFilter from "./ResidentialUnitTypesFilter";
import SiteOperations from "./SiteOperations";
import PTALFilter from "../TripRate/Filters/SecondaryFiltering/PTAL";

export default function ParameterFiltering() {
    const { sessionState } = React.useContext(SessionContext)
    return (
        <Grid container size={12}>
            <Grid container size={4} alignContent={"flex-start"}>
                <SecondaryFilterTickBox
                    title="Location Types"
                    heading="Location"
                    fetchAction="GetMainLocationTypes"
                    path="primaryFilters.locationTypes"
                    id="locationId"
                    alertCondition={(items, selected) => {
                        if (!items?.length) return false;
                        const active = items.filter(
                            f => selected.includes(f.id) && !f.label.includes('(0)')
                        );
                        return active.some(f => active.map(m => m.id).some(s => f.data?.includes(s?.toString()))
                        );
                    }}
                    badgeNumber='1'
                />
                <SecondaryFilterTickBox
                    title="Sub Categories"
                    heading="Sub Location"
                    fetchAction="GetSubLocationTypes"
                    path="primaryFilters.subLocationTypes"
                    id="subLocationId"
                    badgeNumber={'2'}
                />
            </Grid>
            <Grid container size={4} alignContent={"flex-start"}>
                <SecondaryFilterTickBox title={'Use Class'} heading={'Class Code'} fetchAction={'GetSecondaryUseClass'} path={'secondaryFilters.useClasses'} id={'useClass'} canCollapseZeroCounts badgeNumber={'3'} />
                <SecondaryFilterTickBox title={'Travel Plan'} heading={'Travel Plan'} fetchAction={'GetTravelPlan'} path={'secondaryFilters.travelPlan'} id={'travelPlan'} badgeNumber={'4'} />
                <PublicTransportProvision />
            </Grid>
            <Grid container size={4} alignContent={"flex-start"}>

                <PTALFilter heading={'Class Code'} path={'secondaryFilters.ptalRating'} id='ptal' badgeNumber='6' />



                {sessionState.tripRateMain === "01" && (
                    <SecondaryFilterTickBox
                        title='Petrol Station'
                        heading='Petrol Filling Station'
                        fetchAction='GetPetrolFillingStation'
                        fetchParams={`?is1A=${sessionState.tripRateSub === "A"}`}
                        path='secondaryFilters.petrolFillingStation'
                        id='petrolFillingStation'
                        badgeNumber='7'
                    />
                )}

                {sessionState.tripRateMain === "02" && (
                    <SiteOperations />

                )}

                {(
                    (sessionState.tripRateMain === "03" && [
                        "A", "B", "C", "D", "F", "G", "K", "L", "M", "N", "O", "P"
                    ].includes(sessionState.tripRateSub)) ||
                    (sessionState.tripRateMain === "17" && [
                        "A", "B", "C"
                    ].includes(sessionState.tripRateSub))
                ) && (
                        <ResidentialUnitTypesFilter />
                    )}

            </Grid>
        </Grid>
    );
}